<template>
  <Nav></Nav>
  <main class="new-template">
    <back-button></back-button>
    <JsonManager></JsonManager>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Nav from '@/components/Nav.vue';
import JsonManager from '@/components/JsonManager.vue';

export default defineComponent({
  name: 'UploadFile',
  components: {
    BackButton,
    Nav,
    JsonManager,
  },
  data() {
    return {
     
    };
  },
});
</script>